import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../styles/core.scss';
import css from './live-points.scss';
import PointsDisplay from '../points-display/points-display';
import ActivityPointsIcon from '../../assets/images/icon_activity_points.svg';
import LiveMathsPointsIcon from '../../assets/images/icon_livemaths_points.svg';


/**
 * Points Component for Live Maths and Activity
 * Displays points earned by the student for a selected date
 */
class LivePoints extends Component {
    static propTypes = {
        participationInfo: PropTypes.shape({
            activityPoints: PropTypes.number,
            liveMathsPoints: PropTypes.number,
            skillQuestsPoints: PropTypes.number
        }),
        courseResult: PropTypes.shape({
            totalCappedPoints: PropTypes.number,
            goldBars: PropTypes.number
        }),
        localeData: PropTypes.object
    };

    constructor(props) {
        super(props);
        const { localeData } = props;
        const { liveMathsPoints } = this.props.participationInfo;
        const { totalCappedPoints } = this.props.courseResult;
        this.state = {
            livePoints: [{
                title: localeData['Points - LiveMaths'],
                points: liveMathsPoints,
                imageSrc: LiveMathsPointsIcon,
                elementStyle: 'logo-tulip-background'
            },
            {
                title: localeData['Points - Activity'],
                points: totalCappedPoints,
                imageSrc: ActivityPointsIcon,
                elementStyle: 'logo-denim-background'
            }]
        };
    }

    render() {
        const { livePoints } = this.state;

        return (
            <div className={css.component} >

                {livePoints.map(points => (
                    <PointsDisplay
                        key={points.title}
                        elementStyle={points.elementStyle}
                        imgSrc={points.imageSrc}
                        title={points.title}
                        points={points.points} />
                ))}

            </div>);
    }
}

function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}

export default connect(mapStateToProps)(styleable(css)(LivePoints));



// WEBPACK FOOTER //
// ./components/live-points/live-points.js